module.exports = __webpack_public_path__ + "img/COLD_KNIFE.1579071f.jpg";